import React, {
  useContext, useEffect, useState,
} from 'react'
import { VehicleSpecifications as CPVehicleSpecifications } from '@usap/widgets'
import VehicleSpecificationProvider, { VehicleSpecificationsContext } from '../../contexts/vehicleSpecifications.context'

const VSWidget = () => {
  const contextData = useContext(VehicleSpecificationsContext)
  const { vehicleSpecifications } = contextData
  const [hasData, setHasData] = useState(Boolean(vehicleSpecifications?.data))

  useEffect(() => {
    if (vehicleSpecifications?.data) {
      setHasData(true)
    }
  }, [vehicleSpecifications])

  if (!hasData || !vehicleSpecifications) {
    return null
  }

  return (
    <CPVehicleSpecifications vehicleSpecifications={vehicleSpecifications} />
  )
}

export default function VehicleSpecifications({ dynamicApiData }) {
  const {
    vehicle,
    vehicleSpecs,
  } = dynamicApiData || {}

  return (
    <VehicleSpecificationProvider
      vehicle={vehicle}
      vehicleSpecs={vehicleSpecs}
    >
      <VSWidget />
    </VehicleSpecificationProvider>
  )
}
